export default {
    sceneTitle: 'staff_scene_title',
    search: 'global_search_placeholder',
    lastName: 'table_header_name',
    title: 'table_header_job_title',
    email: 'table_header_email',
    actions: 'table_header_actions',
};
